import { h, Component } from 'preact';

export class PasswordForm extends Component {
  constructor(props) {
    super(props);
    var me = this;

    me.state = {
      redirectToken: (new URL(window.location)).searchParams.get("redirectToken") || '',
      focuskey: '',
      email: '',
      password: '',
      emailValid: true,
      pwValid: true,
      errMsg: '',
      errVisible: false,
      loading: false
    }

    document.addEventListener( 'keydown', function (e) {
      if ( e.keyCode == 13 ) {
        document.getElementById('email').blur();
        document.getElementById('pw').blur();
        me.submit(e);
      }
    });
  }

  componentDidMount() {
    if(!this.state.errVisible) {
      document.getElementById('email').focus();
    }
  }

  clearErr() {
    if(this.state.errMsg || this.state.errVisible) {
      this.setState((prevState, props) => ({
        errMsg: '',
        errVisible: false
      }));
    }
  }

  focus = e => {
    if(e.type == 'blur') {
      this.setState((prevState, props) => ({
        focuskey: ''
      }));
    } else {
      this.setState((prevState, props) => ({
        focuskey: e.target.getAttribute("id")
      }));
    }
  }

  hideErr = e => {
    this.setState((prevState, props) => ({
      errVisible: false
    }));
    document.getElementById('pw').select();
    document.getElementById('pw').focus();
  }

  submit = e => {
    var me = this

    if(me.state.errVisible) {
      me.hideErr(e);
    } else if(me.state.errMsg) {
      me.setState((prevState, props) => ({
        errVisible: true
      }));
    }

    if(!me.validateEmail(me.state.email)) {
      me.setState((prevState, props) => ({
        emailValid: false
      }));
      document.getElementById('email').focus();
      return
    }
    if(!me.state.password) {
      me.setState((prevState, props) => ({
        pwValid: false
      }));
      document.getElementById('pw').focus();
      return
    }

    if(me.validateEmail(me.state.email) && me.state.password && !me.state.errMsg) {
      let json = JSON.stringify({
        email: me.state.email,
        password: me.state.password,
        redirectToken: me.state.redirectToken,
      });
      // set loading state
      me.setState((prevState, props) => ({
        loading: true
      }));
      let logo = document.getElementsByClassName('logo-target')[0];
      logo.classList.add('loading');

      fetch('/api/v1/login', {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: json
      }).then(function(responseObj) {
        // console.log(responseObj.status);
        logo.classList.remove('loading');
        if(responseObj.status == 404 || responseObj.status == 401) {
          me.setState((prevState, props) => ({
            errMsg: <span>Authentication Failed<br/>Check your email and password.</span>,
            errVisible: true,
            loading: false
          }));
        } else if(responseObj.status == 400) {
          me.setState((prevState, props) => ({
            errMsg: <span>Unknown Error<br/>Please contact Vigilant support. Your account may be locked.</span>,
            errVisible: true,
            loading: false
          }));
        } else {
          me.setState((prevState, props) => ({
            loading: false
          }));
          responseObj.json().then((data) => {
            switch(responseObj.status) {
            case 201: // new second factor device enrollment required
              me.props.updateAuthStage('deviceEnrollment');
              break;
            case 202: // second factor validation required
              me.props.updateAuthStage('awaitingSecondFactor');
              break;
            }
          });
        }
      });
    }

  }

  updateEmail = e => {
    this.setState((prevState, props) => ({
      email: e.target.value,
      emailValid: this.validateEmail(e.target.value)
    }));
    this.clearErr();
  }

  updatePassword = e => {
    let isValid = this.state.pw != '';
    this.setState((prevState, props) => ({
      password: e.target.value,
      pwValid: isValid
    }));
    this.clearErr();
  }

  validateEmail = email => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render(props, state) {

      var emailPlaceholderClasses = "floating-placeholder";
      var pwPlaceholderClasses = "floating-placeholder";
      if(state.focuskey == 'email') {
        emailPlaceholderClasses += ' float';
      } else if(state.focuskey == 'pw') {
        pwPlaceholderClasses += ' float';
      }

      if(state.email != '') {
        emailPlaceholderClasses += ' hidden';
      }
      if(state.password != '') {
        pwPlaceholderClasses += ' hidden';
      }

      var submitClass = (state.emailValid && state.password.length >= 8)?'primed':'locked';
      submitClass = state.errMsg?(state.errVisible?'error':'errHidden'):submitClass;
      submitClass = state.loading?'loading position-spin':submitClass;

      var outlinerClass = state.focuskey;
      if(!state.emailValid) {
        outlinerClass += ' emailErr';
      }
      if(!state.pwValid) {
        outlinerClass += ' pwErr';
      }

      return  (
        <span class="wizard passwordFormAligner">
          <div id="passwordForm" class={state.loading?' loading':''}>
            <div>
              <div class={emailPlaceholderClasses}>
                <input type="email" id="email" value={state.email}
                  class={state.emailValid?'':'error'}
                  onBlur={this.focus}
                  onFocus={this.focus}
                  onInput={this.updateEmail}
                  onChange={this.updateEmail}/>
                <label for="email" class={state.emailValid?'':'error'}>Email Address</label>
              </div>
            </div>
            <div>
              <div class={pwPlaceholderClasses}>
                <input type="password" id="pw" value={state.password}
                  class={state.pwValid?'':'error'}
                  onBlur={this.focus}
                  onFocus={this.focus}
                  onInput={this.updatePassword}
                  onChange={this.updatePassword}/>
                <label for="password" class={state.pwValid?'':'error'}>Password</label>
              </div>
            </div>
            <div id="errMsg" class={state.errVisible?'':'hidden'}
              onClick={this.hideErr}>
              {state.errMsg}
            </div>
            <button type="button" onClick={this.submit}
              class={"circle-form-button "+submitClass} />
            <div id="input-outliner" class={outlinerClass}/>
          </div>
          <div style="text-align:center;padding:1em;">
            <a href="/forgot-password">Forgot Password?</a>
          </div>
        </span>
      )
  }
}
